import { useFieldArray, useFormContext } from "react-hook-form";
import { CBCreationOfProps, CustomerBaseDto, IFormValues, LinkCustomerData } from "../../types";
import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@mui/material/index";
import { ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { SyntheticEvent, useContext, useEffect, useState } from "react";
import { getErrorKey, extraAddressDtoToForm, getExtraAddressForm } from "../../utils";
import CustomerBaseModal from "../modal/CustomerBaseModal";
import { useRecoilValue } from "recoil";
import CBSearchCustomerWithFiltersDialog from "../modal/CBSearchCustomerWithFiltersDialog";
import { useMutation } from "@tanstack/react-query";
import { linkCustomer, unlinkCustomer } from "../../api/service/customerbaseApi";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import UpdateBtnsAccordion from "../UpdateBtnsAccordion";
import { isGlobalEditModeState } from "../../state/customerbaseState";
import CustomerBaseExtraAddressList from "./CustomerBaseExtraAddressList";

const CustomerBaseExtraAddressesDetails = ({ creationOf}: CBCreationOfProps) => {

    const { dispatchGlobalData } = useContext(GlobalContext);
    const { t } = useTranslation("customerbase");
    const isCreationMode = !!creationOf;
    const { control } = useFormContext<IFormValues>();
    const isGlobalEditMode = useRecoilValue(isGlobalEditModeState);
    const [isExpanded, setIsExpanded] = useState(false);

    const [openAddModal, setOpenAddModal] = useState(false);
    
    const fieldArray = useFieldArray<IFormValues, 'cbExtraAddresses'>({
        name: "cbExtraAddresses",
        control: control
    });

    const onRemoveAddress = (event: SyntheticEvent, index: number, selectedExtraAddress: any) => {
        event.stopPropagation();
        
        fieldArray.remove(index);
        
    }

    const onAddAddressClick = (event: SyntheticEvent) => {
        event.stopPropagation();
        setOpenAddModal(true);
    }

    const onCloseAddAddressModal = () => {
        setOpenAddModal(false);
    }

    const handleCustomerSelected = (selectedCustomer: CustomerBaseDto) => {

        if(!!selectedCustomer) {
            
            if(fieldArray.fields.findIndex(el => el.customerId == selectedCustomer.cbCustomerId) !== -1) {
                
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('message.error.WS04_4000022'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true
                        }
                    }
                });

            } else {
                onCloseAddAddressModal();
                
                fieldArray.append(getExtraAddressForm(selectedCustomer));
            }
        }
    }

    return (
        <>
            <CBSearchCustomerWithFiltersDialog
                title={t("labels.extraAddressSearchCustomerWithFiltersDialogTitle")}
                open={openAddModal}
                onClose={onCloseAddAddressModal}
                onCustomerSelected={handleCustomerSelected}
            />

            <Accordion expanded={isExpanded} onChange={(_e, expanded) => {
                setIsExpanded(expanded)
            }}>
                <AccordionSummary expandIcon={ <ExpandMore/> }>
                    <UpdateBtnsAccordion
                        label={ t("tabs.accordionsLabels.cbExtraAddresses")}
                        editing={(isCreationMode || isGlobalEditMode)}
                        isExpanded={isExpanded}
                        showAdd={(isCreationMode || isGlobalEditMode)}
                        onAdd={onAddAddressClick}
                    />
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container rowSpacing={1}>
                        <CustomerBaseExtraAddressList 
                            isCreationMode={isCreationMode}
                            onRemove={onRemoveAddress}
                        />
                    </Grid>  
                </AccordionDetails>
            </Accordion>
        </>
    )

}

export default CustomerBaseExtraAddressesDetails;